import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:4001',
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
});

// Request interceptor
api.interceptors.request.use(
    config => {
        const token = localStorage.getItem('adminToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        // Check if URL already starts with /api
        if (!config.url.startsWith('/api')) {
            config.url = `/api${config.url}`;
        }
        
        // Log full URL
        const fullUrl = config.baseURL + config.url;
        console.log(`Making ${config.method.toUpperCase()} request to: ${fullUrl}`);
        
        // Debug için
        console.log('API Request:', {
            method: config.method,
            url: config.url,
            fullUrl,
            data: config.data,
            headers: config.headers
        });
        
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// Response interceptor
api.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401 || error.response?.status === 403) {
            localStorage.removeItem('adminToken');
            localStorage.removeItem('adminUser');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default api; 